var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgNoFiles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 353,
    height: 261,
    viewBox: "0 0 353 261",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M215.481 149.489C213.828 151.427 212.043 151.394 210.979 151.121L211.018 150.117C211.018 150.117 215.415 148.136 215.303 148.552C215.262 148.709 215.345 149.084 215.481 149.489Z",
    fill: "#FF4842"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M227.532 151.682C224.725 153.282 223.078 151.407 222.695 150.876C222.931 150.267 223.285 149.279 223.212 148.997C223.106 148.578 227.497 150.56 227.497 150.56L227.532 151.682Z",
    fill: "#FF4842"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M224.525 135.723C224.525 135.723 227.196 134.205 227.779 134.888C228.361 135.571 224.525 135.723 224.525 135.723Z",
    fill: "#FF4842"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M226.138 136.557C226.138 136.557 225.699 136.774 226.668 137.051C227.638 137.329 226.138 136.557 226.138 136.557Z",
    fill: "#FF4842"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M209.985 132.385C209.894 132.411 212.207 133.924 214.296 132.671C214.287 132.671 210.506 132.229 209.985 132.385Z",
    fill: "#FF4842"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M214.182 135.278C214.182 135.278 213.549 136.505 212.252 136.687C210.955 136.869 214.182 135.278 214.182 135.278Z",
    fill: "#FF4842"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M222.673 137.94C222.673 137.94 225.716 142.709 225.134 143.834C224.551 144.959 222.673 137.94 222.673 137.94Z",
    fill: "#FF4842"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M216.669 156.902C216.669 157.168 216.669 157.418 216.642 157.624C216.563 158.588 214.156 158.224 214.156 158.224C211.957 158.525 211.165 157.485 210.904 156.49C210.822 156.167 210.781 155.835 210.783 155.502C210.781 155.303 210.795 155.104 210.822 154.908V154.71C211.296 154.569 211.81 154.673 212.19 154.986C213.168 155.768 214.466 155.168 214.466 155.168C214.466 155.168 215.418 155.246 215.785 155.558C215.992 155.733 216.332 155.311 216.592 154.908C216.607 155.168 216.631 155.638 216.647 156.141C216.664 156.399 216.669 156.659 216.669 156.902Z",
    fill: "#FF4842"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M212.808 156.845C212.808 156.845 212.148 157.483 210.904 156.499C210.821 156.175 210.781 155.843 210.783 155.51C211.418 155.987 212.597 156.845 212.808 156.845Z",
    fill: "#FF4842"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M216.669 156.902C216.56 156.984 216.422 157.019 216.287 156.998C216.151 156.976 216.031 156.901 215.954 156.789C216.211 156.597 216.446 156.379 216.658 156.139C216.664 156.399 216.669 156.659 216.669 156.902Z",
    fill: "#FF4842"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M221.829 157.348C221.829 157.617 221.829 157.866 221.853 158.07C221.932 159.037 224.34 158.671 224.34 158.671C226.539 158.974 227.33 157.934 227.592 156.936C227.721 156.419 227.749 155.882 227.673 155.354V155.157C227.199 155.018 226.685 155.122 226.303 155.432C225.325 156.215 224.03 155.614 224.03 155.614C224.03 155.614 223.078 155.694 222.711 156.007C222.504 156.182 222.163 155.759 221.906 155.356C221.891 155.616 221.864 156.087 221.849 156.59C221.831 156.843 221.827 157.103 221.829 157.348Z",
    fill: "#FF4842"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M225.69 157.288C225.69 157.288 226.35 157.925 227.592 156.941C227.675 156.619 227.716 156.287 227.715 155.955C227.077 156.429 225.899 157.288 225.69 157.288Z",
    fill: "#FF4842"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M221.829 157.348C221.937 157.431 222.075 157.465 222.21 157.444C222.345 157.423 222.465 157.347 222.542 157.236C222.285 157.043 222.049 156.825 221.838 156.585C221.831 156.843 221.827 157.103 221.829 157.348Z",
    fill: "#FF4842"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.05 77.045C235.096 76.9453 235.14 76.8455 235.182 76.748C235.223 76.6505 235.239 76.5963 235.263 76.5182C235.182 76.6898 235.111 76.8656 235.05 77.045Z",
    fill: "#FF4842"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.896 202.609C115.363 201.977 115.119 201.155 115.221 200.339L124.926 122.054L125.731 115.551C125.917 114.055 127.201 112.927 128.73 112.916L157.157 112.729C157.974 112.724 158.756 112.395 159.324 111.815C159.893 111.236 160.2 110.455 160.178 109.649L160.167 109.352C160.139 108.54 160.447 107.75 161.02 107.166C161.593 106.581 162.383 106.251 163.208 106.251H193.079C194.756 106.25 196.116 107.589 196.12 109.242C196.12 109.377 196.111 109.511 196.093 109.645C195.979 110.489 196.234 111.341 196.794 111.988C197.354 112.636 198.168 113.018 199.031 113.039L227.719 113.761C228.602 113.782 229.432 114.181 229.992 114.854C230.553 115.526 230.789 116.406 230.639 117.264L216.297 199.847L216.027 201.408C215.96 201.807 215.81 202.188 215.587 202.527L115.896 202.609Z",
    fill: "#31603F"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 223.282,
    cy: 75.0425,
    rx: 6.8951,
    ry: 6.79743,
    fill: "#00AB55"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.8645,
    height: 30.0003,
    transform: "matrix(0.313192 -0.94969 0.952284 0.305214 239.78 73.8188)",
    fill: "#00AB55"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.8645,
    height: 15.2823,
    transform: "matrix(0.313192 -0.94969 0.952284 0.305214 238.291 78.3333)",
    fill: "#00AB55"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.8645,
    height: 24.7174,
    transform: "matrix(0.313192 -0.94969 0.952284 0.305214 236.799 82.8506)",
    fill: "#00AB55"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.8645,
    height: 30.0003,
    transform: "matrix(0.313192 -0.94969 0.952284 0.305214 235.311 87.3662)",
    fill: "#00AB55"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.60527,
    height: 8.30206,
    transform: "matrix(0.313192 -0.94969 0.952284 0.305214 253.279 102.162)",
    fill: "#00AB55"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M198.03 122.351L164.373 122.709C163.113 122.722 162.098 123.732 162.097 124.974V127.716C162.096 128.945 161.102 129.95 159.855 129.981L135.568 130.555C134.509 130.581 133.569 129.89 133.292 128.882L132.151 124.748C131.877 123.751 130.954 123.063 129.906 123.075L97.4645 123.42C96.7918 123.426 96.1558 123.723 95.7243 124.232C95.2928 124.741 95.1091 125.41 95.2218 126.064L108.273 201.79C108.46 202.876 109.413 203.673 110.531 203.678L213.021 204.111C213.708 204.113 214.36 203.813 214.798 203.292C215.237 202.771 215.417 202.084 215.288 201.419L200.311 124.191C200.102 123.115 199.142 122.34 198.03 122.351Z",
    fill: "#6B9277"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 62.1183,
    cy: 63.0773,
    rx: 4.75577,
    ry: 4.68841,
    fill: "#00AB55"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 290.802,
    cy: 100.543,
    rx: 4.75577,
    ry: 4.68841,
    fill: "#00AB55"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 205.313,
    cy: 48.1884,
    rx: 4.75577,
    ry: 4.68841,
    fill: "#00AB55"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 71.6297,
    cy: 88.9426,
    rx: 7.97026,
    ry: 7.85736,
    fill: "#00AB55"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.517 152.185C145.652 152.185 140.898 156.872 140.898 162.654C140.898 168.437 145.652 173.124 151.517 173.124C157.382 173.124 162.137 168.437 162.137 162.654C162.137 156.872 157.382 152.185 151.517 152.185V152.185Z",
    fill: "#15654C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.72,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.517 153.403C156.7 153.403 160.901 157.545 160.901 162.654C160.901 167.764 156.7 171.906 151.517 171.906C146.334 171.906 142.133 167.764 142.133 162.654C142.137 157.547 146.336 153.408 151.517 153.403Z",
    fill: "#9BEBC2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.126 163.419L146.612 162.925C146.501 162.825 146.438 162.686 146.438 162.539C146.438 162.393 146.501 162.253 146.612 162.153L151.118 157.815C151.222 157.708 151.367 157.647 151.519 157.647C151.671 157.647 151.816 157.708 151.92 157.815L156.426 162.149C156.535 162.251 156.596 162.39 156.596 162.535C156.596 162.681 156.535 162.82 156.426 162.921L155.912 163.416C155.807 163.52 155.663 163.579 155.511 163.579C155.36 163.579 155.215 163.52 155.11 163.416L152.446 160.714V167.125C152.447 167.267 152.389 167.403 152.285 167.504C152.181 167.605 152.04 167.661 151.892 167.661H151.15C150.842 167.661 150.592 167.421 150.592 167.125V160.721L147.928 163.423C147.823 163.527 147.678 163.586 147.526 163.585C147.375 163.584 147.23 163.525 147.126 163.419Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFiles);
export default __webpack_public_path__ + "static/media/no-files.00fb906186907a23629c09d457ca47a8.svg";
export { ForwardRef as ReactComponent };